import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ContextMenu from 'src/components/common/context_menu/ContextMenu';
import { ConfirmationModal } from 'src/components/common/modal/ConfirmationModal';
import { snackbar } from 'src/components/common/snackbar/Snackbar';
import { IQuestionnaireTemplateTableActionsProps } from 'src/features/questionnaire_template/domain/types';
import {
	deleteQuestionnaireTemplate,
	QUESTIONNAIRE_TEMPLATE_LOADING_KEY,
} from 'src/features/questionnaire_template/store/questionnaireTemplateThunks';
import { AppDispatch } from 'src/store';

export const QuestionnaireTemplateTableActions: React.FC<
	IQuestionnaireTemplateTableActionsProps
> = ({
	siteSlug,
	selectedRow,
	anchorElement,
	clearAnchorElement,
	OnActionHit,
	onClose,
}) => {
	const dispatch = useDispatch<AppDispatch>();
	const navigate = useNavigate();

	const [isDeleteModalVisible, setIsDeleteModalVisible] =
		useState<boolean>(false);

	const menuVisible = Boolean(anchorElement);

	const handleDeleteQuestionnaireTemplate = () => {
		dispatch(
			deleteQuestionnaireTemplate({
				questionnaireTemplateId: selectedRow.id,
				siteSlug: siteSlug,
				onSuccess: () => {
					snackbar(
						'Questionnaire template deleted successfully',
						'success',
					);
					setIsDeleteModalVisible(false);
					OnActionHit();
				},
			}),
		);
	};

	return (
		<>
			<ContextMenu
				open={menuVisible}
				onClose={onClose}
				anchorElement={anchorElement}
				clearAnchorElement={clearAnchorElement}
				items={[
					{
						icon: <img src='/FolderViewOutlined.svg' alt='view' />,
						label: 'View',
						onClick: () => {
							navigate(
								`/site/${siteSlug}/questionnaire-template-builder/${selectedRow.id}`,
							);
						},
					},

					{
						icon: (
							<img
								src='/deleteContextMenuIcon.svg'
								alt='delete'
							/>
						),

						label: 'Delete',

						onClick: () => setIsDeleteModalVisible(true),
					},
				]}
			/>

			<ConfirmationModal
				title={`Are you sure you want to delete the questionnaire?`}
				modalContent={`This action cannot be undone. The ${selectedRow.name} and all it's sections, questions and options will be permanently deleted.`}
				modalOpen={isDeleteModalVisible}
				handleYes={handleDeleteQuestionnaireTemplate}
				loadingKey={QUESTIONNAIRE_TEMPLATE_LOADING_KEY}
				handleNo={() => setIsDeleteModalVisible(false)}
			/>
		</>
	);
};
